module.exports = __webpack_public_path__ + "img/linkedin-insightful.b6bb1332.png";